<template>
  <div class="d-flex align-center justify-center fill-height">
    <v-sheet height="90%" width="80%" class="d-flex" color="transparent">
      <div
        :style="`max-width:${$vuetify.breakpoint.xs ? '100%' : '430px'};width:${
          $vuetify.breakpoint.xs ? '100%' : 'auto'
        };`"
        class="d-flex flex-column justify-space-between">
        <div class="text-uppercase d-inline-flex align-center font-weight-bold title grey--text">
          <v-img max-width="200" height="32" src="/img/brand/Envizion_Logo_CastletonGreen.svg" class="mr-4"></v-img>
        </div>
        <div>
          <div class="display-1 font-weight-bold mt-1">Welcome to A V A!</div>
          <div class="mb-5 mt-1   text-capitalize">
            fill out this form to finalize your invitation.
          </div>
          <div class="form-wrapper">
            <v-form id="company-register-form"> 
            <v-label for="name-field" class="black--text font-weight-medium mb-1 d-block"
              >Company Name</v-label
            >
            <v-text-field
              id="company-name-field"
              placeholder="Company Name"
              outlined
              readonly
              dense
              v-model="invitationForm.name"
              type="text"
              :rules="[formRules.required]"></v-text-field>

              <v-label for="first-name-field" class="black--text font-weight-medium mb-1 d-block"
              >First Name</v-label
            >
            <v-text-field
              id="first-name-field"
              placeholder="First Name"
              outlined
               dense
              v-model="invitationForm.owner.firstName"
              type="text"
              :rules="[formRules.required]"></v-text-field>

            <v-label for="last-name-field" class="black--text font-weight-medium mb-1 d-block"
              >Last Name</v-label
            >
            <v-text-field
              id="last-name-field"
              name="last-name-field"
              placeholder="Last Name"
              autocomplete="false"
              outlined
               dense
              v-model="invitationForm.owner.lastName"
              type="text"
              :rules="[formRules.required]"></v-text-field>
            <v-label for="password-field" class="black--text font-weight-medium mb-1 d-block"
              >Password</v-label
            >
            <v-text-field
              id="password-field"
              placeholder="************"
              outlined
               dense
              v-model="invitationForm.owner.password"
              :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showPassword = !showPassword"
              :rules="[formRules.password]"
              :type="showPassword ? 'text' : 'password'"></v-text-field>
            <v-label for="password-field" class="black--text font-weight-medium mb-1 d-block"
              >Confirm Password</v-label
            >
            <v-text-field
              id="password-confirm-field"
              placeholder="************"
              outlined
              dense
              v-model="invitationForm.owner.confirmPassword"
              :append-icon="showCPassword ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="showCPassword = !showCPassword"
              :rules="[
                formRules.confirmPassword(
                  invitationForm.owner.password,
                  invitationForm.owner.confirmPassword,
                ),
              ]"
              :type="showCPassword ? 'text' : 'password'"></v-text-field>

            <v-btn
              :loading="loading"
              large
              block
              color="black"
              class="text-capitalize white--text mt-2"
              @click="register"
              >Complete Account <v-icon right>mdi-arrow-right</v-icon></v-btn
            >
          </v-form>
           <div class="grey--text mt-1">
          Already have a company?
          <router-link class="text-decoration-none black--text font-weight-medium" to="/login">
            Login Using Your Account</router-link
          >
        </div>  
          </div>
        </div>
       
      </div>
      <div class="d-sm-flex pl-16 flex-1 register-img d-none fill-height"></div>
    </v-sheet>
  </div>
</template>

<script>
  import formRules from '@Share/config/form-rules';
  import companyProfileService from '../service/company-profile.service';

  export default {
    name: 'invitation-page',
    data() {
      return {
        showPassword: false,
        showCPassword: false,
        formRules,
        loading: false,
        selectedCompany: '',
        invitationForm: {
          name: '',
          owner: {
            firstName: '',
            lastName: '',
            confirmPassword: '',
            password: '',
          },
        },
      };
    },
    computed: {},
    methods: {
      async register() {
        this.loading = true;
        try {
          await companyProfileService.complete(this.invitationForm, this.$route.params.id);
          this.$router.push('/login');
        } catch (error) {
          console.error('Registration failed:', error);
        } finally {
          this.loading = false;
        }
      },
    },
    async created() {
      try {
        const res = await companyProfileService.getById(this.$route.params.id);
        this.selectedCompany = res.data;
        this.invitationForm.name = this.selectedCompany.name;
      } catch (error) {
        console.error('Failed to load company:', error);
      }
    },
  };
</script>

<style scoped>
  .register-img {
    height: 100%;
    background-image: url('../../../../public/img/invite.svg');
    background-repeat: no-repeat;
    background-size: contain;
    background-origin: content-box;
    background-position: center center;
  }
 
</style>
